import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xuyevs6gm: FaireProductEntity = {
  token: "p_3xuyevs6gm",
  type: "product",
  name: "Menopause Night Relief Patch",
  brandToken: "b_5qdgan4fgk",
  brandName: "Healthogenics",
  imageUrl:
    "https://cdn.faire.com/fastly/3cf51eadee98294efba5e24436052b0505c21fbdb360deddbbf449b962b7a2f6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63a910b4d04eeeff3781ad244d3f772cdd0e5dcf90b94ef194a8ca7e81bc0647.jpeg",
    "https://cdn.faire.com/fastly/ee3ea63a6eccb387a1be18d1c128992c30e89d936774d9125a119ebd5127aab6.jpeg",
    "https://cdn.faire.com/fastly/9192e7330f1f4b9196b6c22ddc45076a74513753db4bcac8d4a17e00f3bcc9d7.jpeg",
    "https://cdn.faire.com/fastly/6989a82268083477c2e06aee45d8acd9a25673e380c84ef314d998f6e49d9b83.jpeg",
    "https://cdn.faire.com/fastly/d861fb2666870bf6c57394795df3aa85601bf67390025ea61f317732f22e53a0.jpeg",
    "https://cdn.faire.com/fastly/32f065dea1bdd61ea8e44e3f056dda079286a0dd7e6af5febb12083f23197d32.jpeg",
    "https://cdn.faire.com/fastly/ca38f458d69940dcf19bff01c868f1b79aeee1468a117e1bcdd692acf71f4554.jpeg",
  ],
  priceDollars: 25,
  description:
    "🌙 Menopause Night Relief Patch\nDoctor-Formulated, Natural Overnight Support for Menopausal Symptoms\n\nRest easy with natural, steady nighttime support.\n\nDesigned by medical experts, the Menopause Night Relief Patch helps ease the disruptive symptoms of menopause while you sleep. This once-daily, transdermal patch delivers gentle, time-released support to promote restful sleep, hormonal balance, and overnight renewal—naturally and without synthetic hormones.\n\nFormulated with calming herbs, essential nutrients, and sleep-supporting botanicals, it’s your natural partner for nightly relief and deep, restorative rest.\n\n🛌 Doctor-Developed Benefits\n• May help reduce night sweats & nighttime hot flashes\n• Supports deeper, more restful sleep\n• May ease nighttime anxiety, restlessness & heart palpitations\n• Helps the body recover from hormonal fatigue\n• Encourages a calm, relaxed state before bed\n• Gentle, long-acting formula designed for overnight use\n\n🧬 How It Works\nUsing advanced transdermal technology, the patch delivers active ingredients through the skin—supporting your body gently and consistently throughout the night.\n\n🔬\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:06.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
